import { Action } from '@ngrx/store';
import { IProductVariant } from '../../model';

// HTTP CRUD

//  CRUD
export enum ProductVariantActionType {
  LOAD_HTTP = '[ProductVariantVariant] Load Http',
  LOAD_HTTP_SUCCESS = '[ProductVariantVariant] Load Http Success',
  LOAD_HTTP_FAIL = '[ProductVariantVariant] Load Http Fail',

  ADD_HTTP = '[ProductVariantVariant] Add Http',
  UPDATE_HTTP = '[ProductVariantVariant] Update Http',
  ADD_UPDATE_HTTP_SUCCESS = '[ProductVariantVariant] Add Update Http Success',
  ADD_UPDATE_HTTP_FAIL = '[ProductVariantVariant] Add Update Http Fail',

  DELETE_HTTP = '[ProductVariantVariant] Delete Http',
  DELETE_HTTP_SUCCESS = '[ProductVariantVariant] Delete Http Success',
  DELETE_HTTP_FAIL = '[ProductVariantVariant] Delete Http Fail',

  UPDATE_DATA_LENGTH = '[ProductVariantVariant] Update Data Length',
  UPDATE_OFFSET = '[ProductVariantVariant] Update Offset',
  UPDATE_LIMIT = '[ProductVariantVariant] Update Limit',

  UPDATE_SEARCH = '[ProductVariantVariant] Update Search',

}

export class LoadHttp implements Action {
  readonly type = ProductVariantActionType.LOAD_HTTP;
  constructor(public payload: any) {}
}

export class LoadHttpSuccess implements Action {
  readonly type = ProductVariantActionType.LOAD_HTTP_SUCCESS;
  constructor(public payload: IProductVariant[]) {}
}
export class LoadHttpFail implements Action {
  readonly type = ProductVariantActionType.LOAD_HTTP_FAIL;
  constructor(public error: any) {}
}

export class AddHttp implements Action {
  readonly type = ProductVariantActionType.ADD_HTTP;
  constructor(public payload: IProductVariant) {}
}

export class UpdateHttp implements Action {
  readonly type = ProductVariantActionType.UPDATE_HTTP;
  constructor(public payload: IProductVariant) {}
}

export class AddUpdateHttpSuccess implements Action {
  readonly type = ProductVariantActionType.ADD_HTTP;
  // comes from effect
  constructor(public payload: IProductVariant) {}
}
export class AddUpdateHttpFail implements Action {
  readonly type = ProductVariantActionType.ADD_UPDATE_HTTP_FAIL;
  constructor(public error: any) {}
}

export class DeleteHttp implements Action {
  readonly type = ProductVariantActionType.DELETE_HTTP;
  constructor(public countryId: number) {}
}

export class DeleteHttpSuccess implements Action {
  readonly type = ProductVariantActionType.DELETE_HTTP_SUCCESS;
  constructor(public payload: any) {}
}

export class DeleteHttpFail implements Action {
  readonly type = ProductVariantActionType.DELETE_HTTP_FAIL;
  constructor(public error: any) {}
}

export class UpdateDataLength implements Action {
  readonly type = ProductVariantActionType.UPDATE_DATA_LENGTH;
  constructor(public dataLength: number) {}
}

export class UpdateOffset implements Action {
  readonly type = ProductVariantActionType.UPDATE_OFFSET;
  constructor() {}
}
export class UpdateLimit implements Action {
  readonly type = ProductVariantActionType.UPDATE_LIMIT;
  constructor(public limit: number) {}
}
export class UpdateSearch implements Action {
  readonly type = ProductVariantActionType.UPDATE_SEARCH;
  constructor(public search: any) { }
}

export type ProductVariantActions =
  | LoadHttp
  | LoadHttpSuccess
  | LoadHttpFail
  | AddHttp
  | UpdateHttp
  | AddUpdateHttpSuccess
  | AddUpdateHttpFail
  | DeleteHttp
  | DeleteHttpSuccess
  | DeleteHttpFail
  | UpdateDataLength
  | UpdateOffset
  | UpdateLimit
  | UpdateSearch;
